import { BoxProps, Flex, Image, Text } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";

interface ISignInSloganProps extends BoxProps {
  signingIn?: boolean;
}

export default function SignInSlogan({ signingIn, ...props }: ISignInSloganProps) {
  return (
    <Flex direction="column" alignSelf="flex-end" ml="50px" mb="66px" {...props}>
      <Flex position="relative" direction="row" alignItems="center" height="60px">
        <Image position="absolute" src="/static/signin/city_1.png" alt="Camden" left="0px" top="0px" />
        <Image position="absolute" src="/static/signin/city_2.png" alt="Toronto" left="30px" top="-4px" />
        <Image position="absolute" src="/static/signin/city_3.png" alt="Boston" left="74px" top="3px" />
        <Image position="absolute" src="/static/signin/city_4.png" alt="Dublin" left="100px" top="-3px" />
        <Image position="absolute" src="/static/signin/city_5.png" alt="Raleigh" left="136px" top="-3px" />
        <Image position="absolute" src="/static/signin/city_6.png" alt="Raleigh" left="176px" top="-3px" />
      </Flex>

      <Text color="white" fontSize="4xl" fontWeight="semibold" lineHeight="42px" mt="30px">
        {signingIn ? (
          <FormattedMessage defaultMessage="Let’s build something great" id="VcajEs" />
        ) : (
          <FormattedMessage defaultMessage="Join the movement" id="py0NPE" />
        )}
      </Text>

      <Text color="white" fontSize="lg" fontWeight="normal" lineHeight="24px" mt="8px" maxWidth="530px">
        {signingIn ? (
          <FormattedMessage
            defaultMessage="Together, we’re building the largest global innovation resource for local government. Let’s figure out what’s working, where."
            id="meEVHx"
          />
        ) : (
          <FormattedMessage
            defaultMessage="Join our community of local government innovators from the smallest towns to the largest cities – and everything in between."
            id="M1uHq0"
          />
        )}
      </Text>
    </Flex>
  );
}
